import { setVis } from "../../../helpers/setVis";
import { changeObjColor } from "../../changeMaterialColor";
import { cloneObject } from "../../cloneObject";
import { hideAndRemove, showHideChildrenByNames } from "../helpers";

// Множественные элементы
export function toggleSceneObject({
    allObjects,
    activeArray,
    name,
    isChecked,
    filterActiveFn, // (el) => boolean, например: el.name.includes(side)
    position = {},
    userData = {},
    hideChildrenName = [],
    excludes = [],
    isStrictName = false,
}) {
    for (let i = activeArray.length - 1; i >= 0; i--) {
        if (!filterActiveFn(activeArray[i])) {
            hideAndRemove(activeArray[i]);
            activeArray.splice(i, 1);
        }
    }

    let newObj = null;
    if (isChecked) {
        let obj = null;
        isStrictName
            ? allObjects.forEach((el) => {
                  if (el.name === name) {
                      obj = el;
                  }
              })
            : allObjects.forEach((el) => {
                  if (el.name.includes(name) && !excludes.some((substr) => el.name.includes(substr))) {
                      obj = el;
                  }
              });

        if (!obj) {
            console.warn("Объект для клонирования не найден", name);
            return;
        }
        newObj = cloneObject(obj);

        if (userData?.placement === "back") {
            // Отзеркаливаем по оси Z
            newObj.scale.z *= -1;

            // Обновляем матрицу
            newObj.matrixNeedsUpdate = true;
        }

        Object.assign(newObj.position, position);

        newObj.userData = { ...newObj.userData, ...userData };

        activeArray.push(newObj);
        servObj.scene.add(newObj);
        setVis(newObj, true);

        hideChildrenName.length
            ? showHideChildrenByNames(newObj, [...hideChildrenName, "hitbox"], false)
            : showHideChildrenByNames(newObj, ["hitbox"], false);
        changeObjColor(activeArray);

        userData.visibleChildren?.length && showHideChildrenByNames(newObj, [...userData.visibleChildren], true);
    }

    if (userData.verticalOnly) {
        const compareKeys = userData.inputCount ? ["type", "name", "inputCount"] : ["type", "name"];
        const newUserData = userData;
        servObj.building._vertical_only = servObj.building._vertical_only.filter((el) => {
            // Если хотя бы один из ключей отсутствует — не удаляем элемент
            if (compareKeys.some((key) => el.userData[key] === undefined || newUserData[key] === undefined)) {
                return true;
            }
            return !compareKeys.every((key) => el.userData[key] === newUserData[key]);
        });
        if (isChecked && newObj) {
            servObj.building.addVerticalObj(newObj);
            servObj.building.restoreObjectColor();
            setTimeout(() => {
                servObj.building.checkCollision();
                !newObj.userData.isIntersect && servObj.building.coloringObject(newObj, servObj.building.blueColor);
            }, 0);
        }
        if (!isChecked) {
            setTimeout(() => {
                servObj.building.checkCollision();
            }, 100);
        }
    }
    if (userData.horizontalOnly) {
        const compareKeys = ["name"];
        const newUserData = userData;
        servObj.building._horizontal_only = servObj.building._horizontal_only.filter((el) => {
            // Если хотя бы один из ключей отсутствует — не удаляем элемент
            if (compareKeys.some((key) => el.userData[key] === undefined || newUserData[key] === undefined)) {
                return true;
            }
            // Если все ключи совпадают — удаляем элемент
            return !compareKeys.every((key) => {
                return el.userData[key] === newUserData[key];
            });
        });
        if (isChecked && newObj) {
            servObj.building.addHorizontalObj(newObj);
            servObj.building.restoreObjectColor();
            setTimeout(() => {
                servObj.building.checkCollision();
                // !newObj.userData.isIntersect && servObj.building.coloringObject(newObj, servObj.building.blueColor);
            }, 0);
        }
        if (!isChecked) {
            setTimeout(() => {
                servObj.building.checkCollision();
            }, 100);
        }
    }

    return newObj;
}
